import { prop } from '@typegoose/typegoose';
import { IsNotEmpty } from 'class-validator';
import { BaseModel } from './base';

export class HseType extends BaseModel {
  name: string;
}
